import React, { useRef, useState, useEffect, useCallback } from "react";

const IMAGES = {
  smoke: "https://images.unsplash.com/photo-1560330833-dae697ec1fda?w=1080&q=80",
  silhouette: "https://images.unsplash.com/photo-1770335377292-7b9397fbc920?w=1080&q=80",
  column: "https://images.unsplash.com/photo-1765513101223-817f6058ff71?w=1080&q=80",
  fire: "https://images.unsplash.com/photo-1767570076534-abf94ea2ec61?w=1080&q=80",
  stage: "https://images.unsplash.com/photo-1571173069043-82a7a13cee9f?w=1080&q=80",
};

const REELS = [
  {
    id: 1,
    title: "Brand Intro",
    duration: 15,
    bgImage: "smoke",
    description: "GPS Method™ logo reveal with cinematic smoke background",
    scenes: [
      { start: 0, end: 2, type: "bg-fade" },
      { start: 1.5, end: 4, type: "text-fade", text: "GPS", x: 0.5, y: 0.35, size: 180, weight: "900", color: "#d9fb06", align: "center" },
      { start: 2.5, end: 5, type: "text-fade", text: "METHOD™", x: 0.5, y: 0.45, size: 100, weight: "900", color: "#d9fb06", align: "center" },
      { start: 4, end: 6.5, type: "line-grow", x: 0.35, y: 0.52, width: 0.3, color: "#d9fb06", thickness: 3 },
      { start: 5, end: 8, type: "text-fade", text: "A System for", x: 0.5, y: 0.58, size: 36, weight: "300", color: "#dfddd6", align: "center" },
      { start: 5.5, end: 8.5, type: "text-fade", text: "Psychological Presence", x: 0.5, y: 0.63, size: 36, weight: "300", color: "#dfddd6", align: "center" },
      { start: 8, end: 11, type: "text-slide-up", text: "Founded by Mel Masry", x: 0.5, y: 0.72, size: 28, weight: "400", color: "#888680", align: "center" },
      { start: 10, end: 13, type: "text-fade", text: "APPLY NOW", x: 0.5, y: 0.82, size: 32, weight: "800", color: "#1a1c1b", align: "center", bg: "#d9fb06", padX: 50, padY: 16 },
      { start: 13, end: 15, type: "fade-out" },
    ],
  },
  {
    id: 2,
    title: "Three Pillars",
    duration: 30,
    bgImage: "column",
    description: "Animated G → P → S pillar reveal with descriptions",
    scenes: [
      { start: 0, end: 2, type: "bg-fade" },
      { start: 1, end: 4, type: "text-fade", text: "THE THREE PILLARS", x: 0.5, y: 0.12, size: 24, weight: "300", color: "#888680", align: "center", letterSpacing: 8 },
      // G
      { start: 3, end: 10, type: "text-scale", text: "G", x: 0.5, y: 0.38, size: 220, weight: "900", color: "#d9fb06", align: "center" },
      { start: 4, end: 10, type: "text-fade", text: "GROUNDING", x: 0.5, y: 0.52, size: 28, weight: "600", color: "#dfddd6", align: "center", letterSpacing: 6 },
      { start: 5, end: 10, type: "text-fade", text: "Root into your body.", x: 0.5, y: 0.58, size: 24, weight: "300", color: "#888680", align: "center" },
      { start: 5.5, end: 10, type: "text-fade", text: "Find your centre.", x: 0.5, y: 0.63, size: 24, weight: "300", color: "#888680", align: "center" },
      // P
      { start: 10, end: 11, type: "wipe" },
      { start: 11, end: 20, type: "text-scale", text: "P", x: 0.5, y: 0.38, size: 220, weight: "900", color: "#d9fb06", align: "center" },
      { start: 12, end: 20, type: "text-fade", text: "PRESENCE", x: 0.5, y: 0.52, size: 28, weight: "600", color: "#dfddd6", align: "center", letterSpacing: 6 },
      { start: 13, end: 20, type: "text-fade", text: "Arrive fully in the moment.", x: 0.5, y: 0.58, size: 24, weight: "300", color: "#888680", align: "center" },
      { start: 13.5, end: 20, type: "text-fade", text: "No past. No future. Just now.", x: 0.5, y: 0.63, size: 24, weight: "300", color: "#888680", align: "center" },
      // S
      { start: 20, end: 21, type: "wipe" },
      { start: 21, end: 28, type: "text-scale", text: "S", x: 0.5, y: 0.38, size: 220, weight: "900", color: "#d9fb06", align: "center" },
      { start: 22, end: 28, type: "text-fade", text: "STRUCTURE", x: 0.5, y: 0.52, size: 28, weight: "600", color: "#dfddd6", align: "center", letterSpacing: 6 },
      { start: 23, end: 28, type: "text-fade", text: "Build the internal architecture", x: 0.5, y: 0.58, size: 24, weight: "300", color: "#888680", align: "center" },
      { start: 23.5, end: 28, type: "text-fade", text: "for authentic expression.", x: 0.5, y: 0.63, size: 24, weight: "300", color: "#888680", align: "center" },
      { start: 27, end: 30, type: "text-fade", text: "GPS METHOD™", x: 0.5, y: 0.8, size: 22, weight: "600", color: "#d9fb06", align: "center", letterSpacing: 4 },
      { start: 28, end: 30, type: "fade-out" },
    ],
  },
  {
    id: 3,
    title: "Presence Quote",
    duration: 15,
    bgImage: "silhouette",
    description: "Cinematic quote reveal — “Presence is not something you perform”",
    scenes: [
      { start: 0, end: 2, type: "bg-fade" },
      { start: 1.5, end: 4.5, type: "text-fade", text: "“", x: 0.15, y: 0.25, size: 200, weight: "400", color: "#d9fb06", align: "left", font: "Georgia, serif", opacity: 0.5 },
      { start: 2, end: 11, type: "text-fade", text: "Presence is not", x: 0.15, y: 0.35, size: 52, weight: "400", color: "#dfddd6", align: "left", font: "Georgia, serif", italic: true },
      { start: 2.8, end: 11, type: "text-fade", text: "something you", x: 0.15, y: 0.42, size: 52, weight: "400", color: "#dfddd6", align: "left", font: "Georgia, serif", italic: true },
      { start: 3.6, end: 11, type: "text-fade", text: "perform.", x: 0.15, y: 0.49, size: 52, weight: "400", color: "#dfddd6", align: "left", font: "Georgia, serif", italic: true },
      { start: 5, end: 11, type: "text-fade", text: "It is something", x: 0.15, y: 0.59, size: 52, weight: "400", color: "#d9fb06", align: "left", font: "Georgia, serif", italic: true },
      { start: 5.8, end: 11, type: "text-fade", text: "you inhabit.", x: 0.15, y: 0.66, size: 52, weight: "400", color: "#d9fb06", align: "left", font: "Georgia, serif", italic: true },
      { start: 8, end: 13, type: "line-grow", x: 0.15, y: 0.74, width: 0.12, color: "#d9fb06", thickness: 2 },
      { start: 9, end: 13, type: "text-fade", text: "— Mel Masry", x: 0.15, y: 0.78, size: 28, weight: "600", color: "#d9fb06", align: "left" },
      { start: 13, end: 15, type: "fade-out" },
    ],
  },
  {
    id: 4,
    title: "Testimonial",
    duration: 30,
    bgImage: "stage",
    description: "Student testimonial with dramatic text transitions",
    scenes: [
      { start: 0, end: 2, type: "bg-fade" },
      { start: 1, end: 8, type: "text-fade", text: "“", x: 0.12, y: 0.18, size: 160, weight: "400", color: "#d9fb06", align: "left", font: "Georgia, serif", opacity: 0.4 },
      { start: 2, end: 10, type: "text-fade", text: "I walked into", x: 0.12, y: 0.3, size: 48, weight: "400", color: "#dfddd6", align: "left", font: "Georgia, serif", italic: true },
      { start: 2.8, end: 10, type: "text-fade", text: "my audition", x: 0.12, y: 0.37, size: 48, weight: "400", color: "#dfddd6", align: "left", font: "Georgia, serif", italic: true },
      { start: 3.6, end: 10, type: "text-fade", text: "differently.", x: 0.12, y: 0.44, size: 48, weight: "400", color: "#d9fb06", align: "left", font: "Georgia, serif", italic: true },
      { start: 6, end: 10, type: "text-fade", text: "I didn’t perform —", x: 0.12, y: 0.55, size: 44, weight: "400", color: "#dfddd6", align: "left", font: "Georgia, serif", italic: true },
      { start: 7, end: 10, type: "text-fade", text: "I arrived.", x: 0.12, y: 0.62, size: 56, weight: "700", color: "#d9fb06", align: "left", font: "Georgia, serif", italic: true },
      // Scene 2
      { start: 10, end: 11, type: "wipe" },
      { start: 12, end: 22, type: "text-fade", text: "Three months into", x: 0.12, y: 0.3, size: 40, weight: "300", color: "#dfddd6", align: "left" },
      { start: 12.8, end: 22, type: "text-fade", text: "the programme,", x: 0.12, y: 0.37, size: 40, weight: "300", color: "#dfddd6", align: "left" },
      { start: 13.6, end: 22, type: "text-fade", text: "everything shifted.", x: 0.12, y: 0.44, size: 40, weight: "600", color: "#d9fb06", align: "left" },
      { start: 16, end: 22, type: "text-fade", text: "I stopped trying to", x: 0.12, y: 0.56, size: 36, weight: "300", color: "#888680", align: "left" },
      { start: 16.8, end: 22, type: "text-fade", text: "‘show’ the panel and", x: 0.12, y: 0.62, size: 36, weight: "300", color: "#888680", align: "left" },
      { start: 17.6, end: 22, type: "text-fade", text: "simply let them see me.", x: 0.12, y: 0.68, size: 36, weight: "300", color: "#888680", align: "left" },
      // Scene 3
      { start: 22, end: 23, type: "wipe" },
      { start: 23, end: 28, type: "text-scale", text: "I BOOKED", x: 0.5, y: 0.4, size: 80, weight: "900", color: "#dfddd6", align: "center" },
      { start: 24, end: 28, type: "text-scale", text: "THE ROLE.", x: 0.5, y: 0.52, size: 80, weight: "900", color: "#d9fb06", align: "center" },
      { start: 26, end: 30, type: "line-grow", x: 0.35, y: 0.6, width: 0.3, color: "#d9fb06", thickness: 3 },
      { start: 27, end: 30, type: "text-fade", text: "GPS METHOD™", x: 0.5, y: 0.7, size: 22, weight: "600", color: "#d9fb06", align: "center", letterSpacing: 4 },
      { start: 28, end: 30, type: "fade-out" },
    ],
  },
  {
    id: 5,
    title: "Stop Acting. Start Being.",
    duration: 15,
    bgImage: "fire",
    description: "Bold statement reel with intense cinematic energy",
    scenes: [
      { start: 0, end: 2, type: "bg-fade" },
      { start: 2, end: 7, type: "text-scale", text: "STOP", x: 0.5, y: 0.3, size: 120, weight: "900", color: "#dfddd6", align: "center" },
      { start: 2.5, end: 7, type: "text-scale", text: "ACTING.", x: 0.5, y: 0.42, size: 120, weight: "900", color: "#dfddd6", align: "center" },
      { start: 5, end: 6, type: "wipe" },
      { start: 6, end: 12, type: "text-scale", text: "START", x: 0.5, y: 0.3, size: 120, weight: "900", color: "#d9fb06", align: "center" },
      { start: 6.5, end: 12, type: "text-scale", text: "BEING.", x: 0.5, y: 0.42, size: 120, weight: "900", color: "#d9fb06", align: "center" },
      { start: 9, end: 13, type: "line-grow", x: 0.3, y: 0.52, width: 0.4, color: "#d9fb06", thickness: 3 },
      { start: 10, end: 13, type: "text-fade", text: "The shift that", x: 0.5, y: 0.6, size: 32, weight: "300", color: "#888680", align: "center" },
      { start: 10.5, end: 13, type: "text-fade", text: "changes everything.", x: 0.5, y: 0.66, size: 32, weight: "300", color: "#888680", align: "center" },
      { start: 11.5, end: 14, type: "text-fade", text: "GPS METHOD™", x: 0.5, y: 0.78, size: 22, weight: "600", color: "#d9fb06", align: "center", letterSpacing: 4 },
      { start: 13, end: 15, type: "fade-out" },
    ],
  },
];

// Easing functions
function easeOutCubic(t) {
  return 1 - Math.pow(1 - t, 3);
}
function easeInOutCubic(t) {
  return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
}

function ReelCanvas({ reel, onReady }) {
  const canvasRef = useRef(null);
  const animRef = useRef(null);
  const startTimeRef = useRef(null);
  const bgImageRef = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [recording, setRecording] = useState(false);
  const [progress, setProgress] = useState(0);
  const recorderRef = useRef(null);
  const chunksRef = useRef([]);

  // Preload background image
  useEffect(() => {
    const img = new Image();
    img.crossOrigin = "anonymous";
    img.src = IMAGES[reel.bgImage];
    img.onload = () => {
      bgImageRef.current = img;
      // Draw initial frame
      drawFrame(0);
    };
  }, [reel]);

  const drawFrame = useCallback((time) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const W = 1080;
    const H = 1920;

    // Clear
    ctx.fillStyle = "#1a1c1b";
    ctx.fillRect(0, 0, W, H);

    // Draw background with Ken Burns
    if (bgImageRef.current) {
      const zoomProgress = time / reel.duration;
      const scale = 1.05 + zoomProgress * 0.15;
      const img = bgImageRef.current;
      const iw = img.width;
      const ih = img.height;
      const coverScale = Math.max(W / iw, H / ih) * scale;
      const dw = iw * coverScale;
      const dh = ih * coverScale;
      const dx = (W - dw) / 2 - zoomProgress * 30;
      const dy = (H - dh) / 2;

      ctx.globalAlpha = 0.2;
      ctx.drawImage(img, dx, dy, dw, dh);
      ctx.globalAlpha = 1;

      // Dark overlay
      ctx.fillStyle = "rgba(26, 28, 27, 0.75)";
      ctx.fillRect(0, 0, W, H);
    }

    // Process scenes
    for (const scene of reel.scenes) {
      if (time < scene.start || time > scene.end) continue;

      const elapsed = time - scene.start;
      const duration = scene.end - scene.start;
      const normalizedTime = elapsed / duration;

      switch (scene.type) {
        case "bg-fade": {
          const opacity = 1 - Math.min(elapsed / 1.5, 1);
          ctx.fillStyle = `rgba(26, 28, 27, ${opacity})`;
          ctx.fillRect(0, 0, W, H);
          break;
        }

        case "text-fade": {
          const fadeIn = Math.min(elapsed / 0.8, 1);
          const fadeOut = scene.end - time < 1 ? (scene.end - time) : 1;
          const alpha = easeOutCubic(fadeIn) * fadeOut * (scene.opacity || 1);
          ctx.globalAlpha = alpha;
          const font = scene.font || "Inter, Arial, sans-serif";
          const italic = scene.italic ? "italic " : "";
          ctx.font = `${italic}${scene.weight} ${scene.size}px ${font}`;
          ctx.fillStyle = scene.color;
          ctx.textAlign = scene.align || "center";
          if (scene.letterSpacing) ctx.letterSpacing = `${scene.letterSpacing}px`;

          const x = scene.x * W;
          const y = scene.y * H;

          if (scene.bg) {
            const metrics = ctx.measureText(scene.text);
            const tw = metrics.width;
            const th = scene.size;
            const px = scene.padX || 0;
            const py = scene.padY || 0;
            ctx.fillStyle = scene.bg;
            const bx = scene.align === "center" ? x - tw / 2 - px : x - px;
            ctx.fillRect(bx, y - th * 0.7 - py, tw + px * 2, th + py * 2);
            ctx.fillStyle = scene.color;
          }

          ctx.fillText(scene.text, x, y);
          ctx.globalAlpha = 1;
          ctx.letterSpacing = "0px";
          break;
        }

        case "text-slide-up": {
          const fadeIn = Math.min(elapsed / 0.8, 1);
          const fadeOut = scene.end - time < 1 ? (scene.end - time) : 1;
          const alpha = easeOutCubic(fadeIn) * fadeOut;
          const slideOffset = (1 - easeOutCubic(fadeIn)) * 40;
          ctx.globalAlpha = alpha;
          ctx.font = `${scene.weight} ${scene.size}px Inter, Arial, sans-serif`;
          ctx.fillStyle = scene.color;
          ctx.textAlign = scene.align || "center";
          ctx.fillText(scene.text, scene.x * W, scene.y * H + slideOffset);
          ctx.globalAlpha = 1;
          break;
        }

        case "text-scale": {
          const fadeIn = Math.min(elapsed / 0.6, 1);
          const fadeOut = scene.end - time < 1 ? (scene.end - time) : 1;
          const alpha = easeOutCubic(fadeIn) * fadeOut;
          const scale = 0.85 + easeOutCubic(fadeIn) * 0.15;
          ctx.save();
          ctx.globalAlpha = alpha;
          ctx.translate(scene.x * W, scene.y * H);
          ctx.scale(scale, scale);
          ctx.font = `${scene.weight} ${scene.size}px Inter, Arial, sans-serif`;
          ctx.fillStyle = scene.color;
          ctx.textAlign = scene.align || "center";
          if (scene.letterSpacing) ctx.letterSpacing = `${scene.letterSpacing}px`;
          ctx.fillText(scene.text, 0, 0);
          ctx.letterSpacing = "0px";
          ctx.restore();
          ctx.globalAlpha = 1;
          break;
        }

        case "line-grow": {
          const growProgress = easeOutCubic(Math.min(elapsed / 1, 1));
          const fadeOut = scene.end - time < 0.5 ? (scene.end - time) * 2 : 1;
          ctx.globalAlpha = fadeOut;
          ctx.strokeStyle = scene.color;
          ctx.lineWidth = scene.thickness;
          ctx.beginPath();
          const startX = scene.x * W;
          const lineY = scene.y * H;
          ctx.moveTo(startX, lineY);
          ctx.lineTo(startX + scene.width * W * growProgress, lineY);
          ctx.stroke();
          ctx.globalAlpha = 1;
          break;
        }

        case "wipe": {
          const wipeProgress = easeInOutCubic(normalizedTime);
          ctx.fillStyle = "#1a1c1b";
          ctx.fillRect(0, 0, W, H * wipeProgress);
          if (wipeProgress > 0.5) {
            const revealProgress = (wipeProgress - 0.5) * 2;
            ctx.clearRect(0, 0, W, H * revealProgress);
            ctx.fillStyle = "#1a1c1b";
            ctx.fillRect(0, 0, W, H);
          }
          break;
        }

        case "fade-out": {
          const alpha = normalizedTime;
          ctx.fillStyle = `rgba(26, 28, 27, ${easeInOutCubic(alpha)})`;
          ctx.fillRect(0, 0, W, H);
          break;
        }

        default:
          break;
      }
    }

    // Watermark
    ctx.globalAlpha = 0.3;
    ctx.font = "600 16px Inter, Arial, sans-serif";
    ctx.fillStyle = "#d9fb06";
    ctx.textAlign = "center";
    ctx.fillText("@gps1way", W / 2, H - 60);
    ctx.globalAlpha = 1;
  }, [reel]);

  const play = useCallback(() => {
    if (playing) return;
    setPlaying(true);
    startTimeRef.current = performance.now();

    const animate = (now) => {
      const elapsed = (now - startTimeRef.current) / 1000;
      if (elapsed >= reel.duration) {
        setPlaying(false);
        setProgress(0);
        drawFrame(0);
        return;
      }
      setProgress(elapsed / reel.duration);
      drawFrame(elapsed);
      animRef.current = requestAnimationFrame(animate);
    };
    animRef.current = requestAnimationFrame(animate);
  }, [playing, reel, drawFrame]);

  const record = useCallback(async () => {
    if (recording) return;
    setRecording(true);
    chunksRef.current = [];

    const canvas = canvasRef.current;
    const stream = canvas.captureStream(30);
    const recorder = new MediaRecorder(stream, {
      mimeType: "video/webm;codecs=vp9",
      videoBitsPerSecond: 8000000,
    });
    recorderRef.current = recorder;

    recorder.ondataavailable = (e) => {
      if (e.data.size > 0) chunksRef.current.push(e.data);
    };

    recorder.onstop = () => {
      const blob = new Blob(chunksRef.current, { type: "video/webm" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `gps-reel-${reel.id}-${reel.title.toLowerCase().replace(/\s+/g, "-")}.webm`;
      a.click();
      URL.revokeObjectURL(url);
      setRecording(false);
    };

    recorder.start();

    // Play the animation
    startTimeRef.current = performance.now();
    const animate = (now) => {
      const elapsed = (now - startTimeRef.current) / 1000;
      if (elapsed >= reel.duration) {
        setProgress(0);
        drawFrame(0);
        recorder.stop();
        return;
      }
      setProgress(elapsed / reel.duration);
      drawFrame(elapsed);
      animRef.current = requestAnimationFrame(animate);
    };
    animRef.current = requestAnimationFrame(animate);
  }, [recording, reel, drawFrame]);

  useEffect(() => {
    return () => {
      if (animRef.current) cancelAnimationFrame(animRef.current);
    };
  }, []);

  return (
    <div>
      {/* Scaled preview */}
      <div style={{ width: 270, height: 480, overflow: "hidden", border: "1px solid rgba(217,251,6,0.15)" }}>
        <canvas
          ref={canvasRef}
          width={1080}
          height={1920}
          style={{ width: 270, height: 480, display: "block" }}
        />
      </div>

      {/* Progress bar */}
      <div style={{ width: 270, height: 3, background: "#302f2c", marginTop: 8 }}>
        <div style={{ width: `${progress * 100}%`, height: "100%", background: "#d9fb06", transition: "width 0.1s" }} />
      </div>

      {/* Controls */}
      <div className="flex gap-2 mt-3">
        <button
          data-testid={`play-reel-${reel.id}`}
          onClick={play}
          disabled={playing || recording}
          style={{
            background: "transparent",
            color: "#d9fb06",
            border: "1px solid #d9fb06",
            padding: "8px 20px",
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 700,
            fontSize: 12,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            cursor: playing ? "not-allowed" : "pointer",
            opacity: playing || recording ? 0.5 : 1,
          }}
        >
          {playing ? "Playing..." : "Preview"}
        </button>
        <button
          data-testid={`record-reel-${reel.id}`}
          onClick={record}
          disabled={playing || recording}
          style={{
            background: "#d9fb06",
            color: "#1a1c1b",
            border: "none",
            padding: "8px 20px",
            fontFamily: "Inter, Arial, sans-serif",
            fontWeight: 700,
            fontSize: 12,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            cursor: recording ? "wait" : "pointer",
            opacity: playing || recording ? 0.6 : 1,
          }}
        >
          {recording ? "Recording..." : "Record & Download"}
        </button>
      </div>
    </div>
  );
}

export default function ReelsStudio() {
  return (
    <div
      data-testid="reels-studio-page"
      style={{ background: "#1a1c1b", minHeight: "100vh", padding: "120px 40px 80px" }}
    >
      <div style={{ maxWidth: 1200, margin: "0 auto 60px" }}>
        <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 300, fontSize: 14, color: "#888680", letterSpacing: "0.3em", textTransform: "uppercase", marginBottom: 16 }}>
          Reels Studio
        </div>
        <h1 className="brand-display" style={{ fontSize: "clamp(2.5rem, 4vw, 5rem)", marginBottom: 20 }}>
          MOTION REELS
        </h1>
        <p style={{ color: "#888680", fontSize: 18, maxWidth: 700, lineHeight: 1.6 }}>
          {REELS.length} cinematic Instagram Reels for GPS Method™. Preview each reel, then hit
          "Record & Download" to export as video. Add your own music in Instagram before posting.
        </p>
        <div style={{ marginTop: 16, padding: "12px 20px", background: "#302f2c", display: "inline-block", fontSize: 14, color: "#dfddd6" }}>
          Format: 9:16 vertical (1080×1920) • Duration: 15–30 seconds • Export: WebM video
        </div>
      </div>

      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        {/* Grid of reels */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 40 }}>
          {REELS.map((reel) => (
            <div key={reel.id} style={{ paddingBottom: 40, borderBottom: "1px solid rgba(217,251,6,0.1)" }}>
              <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 700, fontSize: 13, color: "#d9fb06", letterSpacing: "0.15em", marginBottom: 8 }}>
                REEL {String(reel.id).padStart(2, "0")} • {reel.duration}s
              </div>
              <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 600, fontSize: 18, color: "#dfddd6", marginBottom: 4 }}>
                {reel.title}
              </div>
              <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 300, fontSize: 14, color: "#888680", marginBottom: 16 }}>
                {reel.description}
              </div>
              <ReelCanvas reel={reel} />
            </div>
          ))}
        </div>

        {/* Instructions */}
        <div style={{ marginTop: 80, padding: 40, background: "#302f2c" }}>
          <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 700, fontSize: 16, color: "#d9fb06", marginBottom: 16 }}>
            HOW TO POST YOUR REEL
          </div>
          <div style={{ fontFamily: "Inter, Arial, sans-serif", fontWeight: 300, fontSize: 15, color: "#dfddd6", lineHeight: 1.8 }}>
            1. Click "Record & Download" on any reel to export as video<br />
            2. Transfer the .webm file to your phone (AirDrop, Google Drive, email)<br />
            3. Open Instagram → Create Reel → Select your video<br />
            4. Add music (search for dark/cinematic tracks) and adjust timing<br />
            5. Write your caption, add hashtags, and post!<br /><br />
            <span style={{ color: "#888680" }}>
              Tip: For best results, convert .webm to .mp4 using a free tool like CloudConvert.com before uploading to Instagram.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
